import { render } from "./DriverStatusApiDocs.vue?vue&type=template&id=bcfa2a40&scoped=true&ts=true"
import script from "./DriverStatusApiDocs.vue?vue&type=script&lang=ts"
export * from "./DriverStatusApiDocs.vue?vue&type=script&lang=ts"

import "./DriverStatusApiDocs.vue?vue&type=style&index=0&id=bcfa2a40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfa2a40"]])

export default __exports__